<style scoped>
.modal-content {
  text-align: center;
}

@media (max-width: 400px) {
  .item-icons a{
    margin-left: 1px;
    padding-left: 5px;
    padding-right: 5px;
    margin-right: 1px;
  }
}
</style>

<style>
.overlay--close {
  background-image: url(/img/icon__sharp-close-24px.5b3f560c.svg) !important;
  right: 0 !important;
  left: auto !important;
  top: 0 !important;
}

.overlay--start-new-content__buttons {
  opacity: auto !important;
  -webkit-transform: none !important;
  transform: none !important;
}
</style>

<template>
  <div class="overlay--start-new-content">
    <div class="modal-content">
      <div v-if="!list">
        <a
          href="#"
          @click.prevent="closeAndGo('CreateList');"
          class="button button__new-list"
        >Create a new list</a>
        <div class="type1-semibold">Or add a new item</div>
      </div>
      <div class="item-icons">
      <a
        @click.prevent="closeAndGo('AddItem', {mode: 'Product'});"
        href="#"
        class="button__new-item w-inline-block"
      >
        <div class="button__new-item__icon"></div>
        <div class="type-1-semibold button__new-item__label">Product</div>
      </a>
      <a
        href="#"
        class="button__new-item w-inline-block"
        @click.prevent="closeAndGo('AddItem', {mode: 'Place'});"
      >
        <div class="button__new-item__icon place"></div>
        <div class="type-1-semibold button__new-item__label">Place</div>
      </a>
      <a
        href="#"
        class="button__new-item w-inline-block"
        @click.prevent="closeAndGo('AddItem', {mode: 'Generic'});"
      >
        <div class="button__new-item__icon text"></div>
        <div class="type-1-semibold button__new-item__label">Text</div>
      </a>
      <a
        href="#"
        class="button__new-item w-inline-block"
        @click.prevent="closeAndGo('AddItem', {mode: 'Media'});"
      >
        <div class="button__new-item__icon media"></div>
        <div class="type-1-semibold button__new-item__label">Media</div>
      </a>
      </div>
    </div>
    <a @click.prevent="$emit('close')" href="#" class="overlay--close w-inline-block"></a>
  </div>
</template>

<script>
import { ItemType } from '@/models/items/abstract-item-model';

export default {
  props: ['list'],
  methods: {
    closeAndGo(name, params = {}) {
      
      this.$emit('close');
      params.list = this.list;

      const query = {
        mode: params.mode
      };

      if (this.list) {
        query['listId'] = this.list.id;
      }

      this.$router.push({ name, params, query });
    }
  }
};
</script>